export default "__VITE_ASSET__CrmG0C1L__"